__turbopack_context__.v({
  "caption": "wiki-infobox-module__53dNwq__caption",
  "emblem": "wiki-infobox-module__53dNwq__emblem",
  "fields": "wiki-infobox-module__53dNwq__fields",
  "figure": "wiki-infobox-module__53dNwq__figure",
  "header": "wiki-infobox-module__53dNwq__header",
  "image": "wiki-infobox-module__53dNwq__image",
  "infobox": "wiki-infobox-module__53dNwq__infobox",
  "row": "wiki-infobox-module__53dNwq__row",
  "title": "wiki-infobox-module__53dNwq__title",
  "types": "wiki-infobox-module__53dNwq__types",
});
